import { FC } from 'react';
import { Button, Col, Collapse, Divider, Row, Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import Paragraph from 'antd/lib/typography/Paragraph';
import Page from '../../Components/Page/Page';
import BookyBox from '../../Components/Layout/BookyBox';
import { TextService } from '../../Services/TextService';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import { useNavigate } from 'react-router-dom';

const PartnerPingPayments = () => {
    const GetText = TextService.GetText;
    return <Page pageTitle={GetText("PageTitle_PingPayments")}>
        <BookyBox>
            <Title>Integration till PingPayments</Title>

            <Paragraph>OneFront 360 kan nu erbjuda en tidsbesparande integration till PingPayments för företag och föreningar.<br /><br />
                Integrationen till Ping Payments möjliggör att automatisera medlemsavprickning av fakturering av medlemsbetalningar. Betallänk går att skapa och skicka direkt till medlemmens e-postadress från OneFront 360, medlemen kan sen direkt betala in via swish eller internetbetalning. Det går också att skriva ut en PDF med inbetalningsinformation och skicka ut med vanlig post. Efter inbetalningen kommer medlemsavgiften prickas av automatiskt i OneFront 360.
                För att använda integrationen behöver du ha ett konto hos OneFront 360, <a href={"/" + getCurrentLanguage() + "/Pricing"}>läs mer och skapa konto.</a>
            </Paragraph>
            <br /><br />
            <h2>Om PingPayments</h2>
            <img
                alt="pingpayments logotype"
                style={{ width: "400px", height: "auto", marginBottom: "20px" }}
                src={require('../../Images/pingpayments.png')}
            />
            <Paragraph>
                Ping levererar en komplett lösning för alla betalbehov och erbjuder en effektiv, trygg och lyhörd helhetsleverans.
                Tillsammans minskar vi er administrativa arbetsbörda, sänker era kostnader och frigör resurser. <a target="_blank" href="https://www.pingpayments.com">www.pingpayments.com</a>
            </Paragraph>
        </BookyBox>
    </Page>
};

export default PartnerPingPayments;